import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Types.Person.Address
 * 
 * Endpoints: /api/Adress, /api/BankOperation/update, /api/v2/versicherungen/fahrrad/anlage, /api/FreundschaftsWerbung/Empfehlungslink, /api/Identity, /api/v2/kuendigung/kuendigerstatus, /api/MeineDaten/vesvertraege, /api/mitgliedschaft, /api/mitgliedschaft/zusammenfuehren, /api/versicherungen/brs/anlage, /api/versicherungen/us/pruefen, /api/versicherungen/brs/angebot, /api/versicherungen/brs/leseangebot, /api/zuhause/schutzbrief/anlage, /api/zuhause/schutzbrief/angebot, /api/zuhause/schutzbrief/angebotlesen
 */
export class AddressApi extends BaseApiModel {
	constructor(initialProperties?: Partial<AddressApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected postfachbezeichnung: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Postfachbezeichnung(): string {
		return this.postfachbezeichnung;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Postfachbezeichnung(value: string) {
		this.postfachbezeichnung = value;
	}

	protected postfachnummer: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Postfachnummer(): string {
		return this.postfachnummer;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Postfachnummer(value: string) {
		this.postfachnummer = value;
	}

	protected strasseHausnummer: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get StrasseHausnummer(): string {
		return this.strasseHausnummer;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set StrasseHausnummer(value: string) {
		this.strasseHausnummer = value;
	}

	protected strasse: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Strasse(): string {
		return this.strasse;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Strasse(value: string) {
		this.strasse = value;
	}

	protected hausnummer: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Hausnummer(): string {
		return this.hausnummer;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Hausnummer(value: string) {
		this.hausnummer = value;
	}

	protected postleitzahl: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Postleitzahl(): string {
		return this.postleitzahl;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Postleitzahl(value: string) {
		this.postleitzahl = value;
	}

	protected ort: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Ort(): string {
		return this.ort;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Ort(value: string) {
		this.ort = value;
	}

	protected ergaenzungszeile: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Ergaenzungszeile(): string {
		return this.ergaenzungszeile;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Ergaenzungszeile(value: string) {
		this.ergaenzungszeile = value;
	}

	protected auslandsadresse: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Auslandsadresse(): boolean {
		return this.auslandsadresse;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Auslandsadresse(value: boolean) {
		this.auslandsadresse = value;
	}

	protected landkennzeichen: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Landkennzeichen(): string {
		return this.landkennzeichen;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Landkennzeichen(value: string) {
		this.landkennzeichen = value;
	}

	protected regionalclubKennung: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get RegionalclubKennung(): string {
		return this.regionalclubKennung;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set RegionalclubKennung(value: string) {
		this.regionalclubKennung = value;
	}

	protected regionalclubCode: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get RegionalclubCode(): string {
		return this.regionalclubCode;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set RegionalclubCode(value: string) {
		this.regionalclubCode = value;
	}

	protected ortsnummer: number;
	/**
	 * Description: 
	 * APIL Type: int64
	 */
	get Ortsnummer(): number {
		return this.ortsnummer;
	}

	/**
	 * Description: 
	 * APIL Type: int64
	 */
	set Ortsnummer(value: number) {
		this.ortsnummer = value;
	}

	protected gemeindenummer: number;
	/**
	 * Description: 
	 * APIL Type: int64
	 */
	get Gemeindenummer(): number {
		return this.gemeindenummer;
	}

	/**
	 * Description: 
	 * APIL Type: int64
	 */
	set Gemeindenummer(value: number) {
		this.gemeindenummer = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AddressApi {
		return AppUtils.Helper.createFromMap(dataObject, AddressApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Postfachbezeichnung = this.postfachbezeichnung;
		result.Postfachnummer = this.postfachnummer;
		result.StrasseHausnummer = this.strasseHausnummer;
		result.Strasse = this.strasse;
		result.Hausnummer = this.hausnummer;
		result.Postleitzahl = this.postleitzahl;
		result.Ort = this.ort;
		result.Ergaenzungszeile = this.ergaenzungszeile;
		result.Auslandsadresse = this.auslandsadresse;
		result.Landkennzeichen = this.landkennzeichen;
		result.RegionalclubKennung = this.regionalclubKennung;
		result.RegionalclubCode = this.regionalclubCode;
		result.Ortsnummer = this.ortsnummer;
		result.Gemeindenummer = this.gemeindenummer;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}